"use client";
import { useFilters } from "@/hooks";
import { Filters, TreeNode } from "@/types/General";
import { ComponentProps, FC, useEffect, useMemo } from "react";
import { Filter } from "./Filter";
import { generatePaths } from "@/helpers";
type HorizontalFilterProps = {
  filters: {
    label: string;
    name: string;
    placeholder?: string;
    categories: TreeNode[];
    multiple?: boolean;
    selectAllText?: string;
  }[];
  selectedFilters: Filters;
  onFilter: (filters: Filters) => void;
} & ComponentProps<"div">;

export const HorizontalFilter: FC<HorizontalFilterProps> = ({
  filters,
  selectedFilters: initialSelectedFilters,
  onFilter,
  ...props
}) => {
  const {
    setSelectedFilters,
    selectedFilters: internalSelectedFilters,
    setFilter,
  } = useFilters(initialSelectedFilters);

  useEffect(() => {
    setSelectedFilters(initialSelectedFilters);
  }, [initialSelectedFilters, setSelectedFilters]);

  const options = [
    ...new Set(
      filters.flatMap((filter) =>
        filter.categories
          .flatMap((category) => generatePaths(category))
          .map((filter) => filter.path),
      ),
    ),
  ];

  return (
    <div {...props}>
      {filters.map((filter) => {
        const selectedFilter = internalSelectedFilters.find(
          ({ name }) => name === filter.name,
        );
        return (
          <Filter
            multiple={filter.multiple}
            key={filter.name}
            placeholder={filter.placeholder || filter.label}
            options={options}
            onFilter={(filters) => {
              const newFilters = setFilter(filter.name, filters);
              onFilter(newFilters);
            }}
            selectedFilters={selectedFilter?.paths ?? []}
            selectAllText={filter.selectAllText}
          />
        );
      })}
    </div>
  );
};
